import { k } from "../kaplay";

k.loadRoot("./");
k.loadSprite("player", "sprites/glady-o.png");
k.loadSprite("zombie", "sprites/zombean-o.png");
k.loadSprite("ghost", "sprites/ghostiny-o.png");
k.loadSprite("giga", "sprites/gigagantrum-o.png");
k.loadSprite("sword", "sprites/sword-o.png");
k.loadSprite("spike", "sprites/spike-o.png");
k.loadSprite("fire", "sprites/fire-o.png");
k.loadSprite("trees", "sprites/trees.png");
k.loadSprite("card", "sprites/card.png");
k.loadSprite("steel", "sprites/steel.png");
k.loadSprite("mushroom", "sprites/mushroom.png");
k.loadSprite("skull", "sprites/skuller.png");
k.loadSprite("play", "sprites/play-o.png");
k.loadSprite("heart", "sprites/heart-o.png");
k.loadSprite("xpBar", "sprites/xp_bar.png");